module.exports = __webpack_public_path__ + "b737b5fec2b89fe0e06ec03945e79544.png";